import React from "react";
import { Divider, Tag, Tooltip, Typography } from "antd";
import { GithubOutlined, GlobalOutlined } from "@ant-design/icons";
import { ResumeProject as ResumeProjectType } from "../../Entities/UserProfile";

const ProjectCard: React.FC<{
  projectName: string;
  description: string;
  technologies: string[];
  githubLink: string | null;
  liveLink: string | null;
}> = ({ projectName, description, technologies, githubLink, liveLink }) => {
  return (
    <div className="project-card">
      <div className="project-card-header">
        <div className="project-card-title">
          <Typography.Text strong>{projectName}</Typography.Text>
        </div>
        <div className="project-card-header-actions">
          {githubLink && (
            <Tooltip title="View on GitHub">
              <a href={githubLink} target="_blank" rel="noreferrer">
                <Tag className="resume-social-tag">
                  <GithubOutlined />
                </Tag>
              </a>
            </Tooltip>
          )}
          {liveLink && (
            <Tooltip title="View Live">
              <a href={liveLink} target="_blank" rel="noreferrer">
                <Tag className="resume-social-tag">
                  <GlobalOutlined />
                </Tag>
              </a>
            </Tooltip>
          )}
        </div>
      </div>
      <Typography.Paragraph
        type="secondary"
        style={{ fontSize: "13px", fontStyle: "italic", margin: 0 }}
      >
        {description}
      </Typography.Paragraph>
      {technologies.length > 0 && (
        <div className="resume-preview-skills-list">
          {technologies.map((t, i) => (
            <Tag key={i} color="processing">
              {t}
            </Tag>
          ))}
        </div>
      )}
    </div>
  );
};

interface ResumeProjectProps {
  projects: ResumeProjectType[];
}

const ResumeProject: React.FC<ResumeProjectProps> = ({ projects }) => {
  return (
    <div className="resume-preview-card">
      <div className="resume-preview-card-header">
        <div className="resume-preview-card-header-title">
          <span className="material-symbols-outlined" style={{ margin: 0 }}>
            assignment_turned_in
          </span>
          <Typography.Title level={5} style={{ margin: 0 }}>
            Projects
          </Typography.Title>
        </div>
      </div>
      <Divider style={{ margin: 0 }} />

      <div className="resume-preview-project-list">
        {projects.map((p, i) => (
          <ProjectCard
            key={i}
            projectName={p.title}
            description={p.description}
            technologies={p.technologies || []}
            githubLink={p.githubLink}
            liveLink={p.liveLink}
          />
        ))}
      </div>
    </div>
  );
};

export default ResumeProject;
